import React from "react";

/**
 * Pagination controls for the expense history
 * Shows Previous/Next buttons with current page indicator
 *
 * Mobile-first design:
 * - Large 44px+ touch targets
 * - Simple Previous/Next navigation
 * - Page counter for context
 * - Hides when not needed (< 10 items total)
 */
function PaginationControls({
  currentPage,
  hasMoreItems,
  onPreviousPage,
  onNextPage,
  disabled,
  totalItems,
  itemsPerPage = 10,
}) {
  // Don't show pagination if total items fit on one page
  if (totalItems <= itemsPerPage && currentPage === 0) {
    return null;
  }

  return (
    <div className="pagination-controls">
      <button
        className="pagination-btn pagination-prev"
        onClick={onPreviousPage}
        disabled={disabled || currentPage === 0}
        aria-label="Go to previous page"
      >
        ← Previous
      </button>

      <div className="pagination-info">
        <span className="page-number">Page {currentPage + 1}</span>
        {totalItems > 0 && (
          <span className="items-info">
            {Math.min((currentPage + 1) * itemsPerPage, totalItems)} of {totalItems}
          </span>
        )}
      </div>

      <button
        className="pagination-btn pagination-next"
        onClick={onNextPage}
        disabled={disabled || !hasMoreItems}
        aria-label="Go to next page"
      >
        Next →
      </button>
    </div>
  );
}

export default PaginationControls;
